import React from "react";
import { isMobileSlidingDraftExpired } from "../lib/draftAccess";
import SlidingDraftExpiredPage from "./SlidingDraftExpiredPage";

/** Blocks mobile-draft app pages after the configured expiry date. */
export default function SlidingDraftGate({ children }) {
    if (isMobileSlidingDraftExpired()) {
        return <SlidingDraftExpiredPage />;
    }
    return children;
}
